(function ($) {
  'use strict';

  /**
   * Collection - Content Block - Mobile - v1
   */
  Drupal.behaviors.collectionContentBlockMobileV1 = {
    attach: function (context, settings) {
      var legacyView = 'collection-classic-legacy-view';
      var legacyColumnRequested = $('.collection-classic-product-column').length;

      if ($('.js-collection-landing-view-all').attr('href') && $('.layout--collection-detail').length && !legacyColumnRequested) {
        var $readMoreShowLess = $('.js-collection-landing-more-less');
        var $landingBrickContent = $('.collection-landing-brick__content');
        var readMoreClass = 'collection-landing-brick__read-more';
        var showLessClass = 'collection-landing-brick__show-less';
        var rowTidy = false;

        // Treat rendered products as skus.
        $('.product--collection-dual').addClass('product--sku-product');

        window.onload = function () {
          setTimeout(function () {
            tidyUp();
            Drupal.behaviors.mobileCollectionCarouselV1.loadCarousel();
          }, 0);
        };

        // Allow the new column view
        $('.collection-classic-legacy-view').removeClass(legacyView);
        $('.column-layout').show();

        // Landing Header Caption
        $('.collection-landing-brick__caption ').addClass('js__collection-landing_column_caption');

        // Single Column.
        $('.js-col-single').on('click', function () {
          // Remove All Dual Column classes.
          classToggle(false);
          Drupal.behaviors.mobileCollectionCarouselV1.loadCarousel();
        });

        // Dual Column.
        $('.js-col-double').on('click', function () {
          // Dual Product Column Layout.
          classToggle(true);
          Drupal.behaviors.mobileCollectionCarouselV1.loadCarousel();

          // Adjust row hieght based on the row's biggest header details.
          tidyRow('.product_header_details', 2, '.collection-dual-product-layout');
        });

        // Read more / Show less Toggle.
        $readMoreShowLess.text($readMoreShowLess.data('read-more'));

        $landingBrickContent.addClass(readMoreClass);
        var h = $landingBrickContent[0] ? $landingBrickContent[0].scrollHeight + 10 : 0;

        $readMoreShowLess.toggle(function () {
          $landingBrickContent.animate({
            'height': h
          });
          $readMoreShowLess.text($readMoreShowLess.data('show-less'));
          $landingBrickContent.removeClass(readMoreClass);
          $landingBrickContent.addClass(showLessClass);
        }, function () {
          $landingBrickContent.animate({
            'height': '30px'
          });
          $readMoreShowLess.text($readMoreShowLess.data('read-more'));
          $landingBrickContent.removeClass(showLessClass);
          $landingBrickContent.addClass(readMoreClass);
        });
      } else {
        // Add Header Nav Back.
        $('.collection-detail-formatter__mobile-subnav').show();
        if (!legacyColumnRequested) {
          $('.js-single-column').wrapInner("<div class='" + legacyView + "'></div>");
        }
      }

      var refLink = $('.article-reference__link > a', context);

      refLink.each(function (index) {
        // Article Reference accordion
        var refLinkTxt = $(this).text();

        $(this).on('click', function () {
          var ref = $(this).parents('.collection-content-block-mobile').siblings('.article-reference');
          // @todo add translation for text
          var newTxt = ref.is(':visible') ? refLinkTxt : 'Close';

          $(this).text(newTxt);
          ref.slideToggle('fast');

          return false;
        });

        // Sometimes we want to access the article directly
        var refLinkID = $(this).attr('href').substr(1);

        if (window.location.hash.substr(1) == refLinkID) {
          $(this)
            .hide()
            .parents('.collection-content-block-mobile')
            .siblings('.article-reference')
            .show();
        }
      });

      // Collection products list
      // Reveal & Hide - piggy-backed on existing Overlay clickaway functionality
      $('.overlay-clickaway', context).on('click', '.overlay-clickaway__starting', function (e) {
        $(this).parents('.overlay-clickaway').siblings('.collection-products__list')
          .show();
        var offsetTop = $(this).parents('.overlay-clickaway').find('.overlay-clickaway__content').offset().top;
        var headerHeight = $('.site-header').height();

        $('html, body').scrollTop(offsetTop - headerHeight);
      });
      $('.collection-products__list--close > a', context).on('click', function () {
        $(this).parents('.overlay-clickaway__content').siblings('.overlay-clickaway__starting')
          .fadeIn(300)
          .parents('.overlay-clickaway').siblings('.collection-products__list')
          .slideToggle('fast');
      });

      // Applies and Removes Classes for Column Layouts
      function classToggle(addingClass) {
        var classes = {
          '.collection-products__list--item:odd': 'collections-double-col-one',
          '.collection-products__list--item:even': 'collections-double-col-two',
          '.product__images': 'col-image'
        };

        if (addingClass == true) {
          _.each(classes, function (value, key) {
            $(key).addClass(value);
          });
          // Dual Product Column Layout.
          $('.collection-products__list').removeClass('js-single-column');
          $('.collection-products__list').addClass('js-double-column');
          // Active Layout Button.
          $('.js-col-double').addClass('layout-active');
          $('.js-col-single').removeClass('layout-active');
        } else {
          // Single Product Column Layout.
          $('.collection-products__list').addClass('js-single-column');
          $('.collection-products__list').removeClass('js-double-column');
          _.each(classes, function (value, key) {
            $(key).removeClass(value);
          });
          // Active Layout Button
          $('.js-col-double').removeClass('layout-active');
          $('.js-col-single').addClass('layout-active');
        }
      }

      // Custom varying but equal row heights.
      function tidyRow(elementToMakeTidy, columns, targetWrapper, delimiterlass) {
        // Multi Nodeblock-Reference Check.
        $('.basic-nodeblock-reference-v1').each(function (index) {
          // Default : Search entire node-ref or search through specified boundary.
          var classConfine = delimiterlass || $(this),
            collectionGroup = classConfine.find(targetWrapper);

          if (collectionGroup.length) {
            //  The elements we are making uniform.
            var dissimilarElements = collectionGroup.find(elementToMakeTidy),
              counter = 0,
              elements = dissimilarElements.length;

            if (columns == 0) {
              // Use Match Height from here.
              dissimilarElements.matchHeight();
            } else {
              if (elements) {
                var rows = [];

                while (elements--) {
                  // Items per row  dictated by amount of columns.
                  var isRowEnd = Math.floor(counter / columns);

                  if (!rows[isRowEnd]) {
                    rows[isRowEnd] = $();
                  }
                  rows[isRowEnd] = rows[isRowEnd].add(dissimilarElements[counter]);
                  ++counter;
                }
                // Finding biggest clientHeight per row.
                $.each(rows, function (i, p) {
                  var max = 0;

                  // Going through the row's items.
                  $.each(p, function (i, rowsItem) {
                    if (rowsItem.clientHeight > max) {
                      // Set only the highest height of the row.
                      max = rowsItem.clientHeight;
                    }
                  });
                  elements = dissimilarElements.length;
                  // Apply equal height to the all of the row's items.
                  $.each(p, function (i) {
                    rowTidy = true;
                    var element = dissimilarElements[elements - counter];

                    element.style.height = max + 'px';
                    --counter;
                  });
                });// Continue to next row.
              }
            }
          } else {
            return;
          }
        });
      }
      function tidyUp() {
        // Uniform row at end of call stack.
        setTimeout(function () {
          $('.mobile-collection-products-carousel.slick-slider').each(function (index) {
            // Uniform Row.
            tidyRow('.product__header', 0, '.collection-products__list--item', $(this));
            tidyRow('.product__images', 0, '.collection-products__list--item', $(this));
          });
          $('.js-single-column').fadeIn(300);
        }, 0);
      }
      tidyUp();
    }
  };

  /**
   * Collection - Mobile collection carousel - v1
   */
  Drupal.behaviors.mobileCollectionCarouselV1 = {
    // Load The Carousel.
    loadCarousel: function () {
      // vars for slick
      var carousel = $('.js-mobile-collection-products-carousel', 'body'),
        localizedShades = $('.js-mobile-collection-single-products-wrapper').data('shades'),
        productsSlide = '.js-mobile-collection-slide';

      // Render the carousel.
      carousel.unslick();
      carousel.slick({
        autoplay: false,
        speed: 300,
        dots: true,
        accessibility: true,
        slide: productsSlide,
        slidesToShow: 1,
        slidesToScroll: 1,
        customPaging: function (slider, i) {
          var btnTxt = $('.product__add-to-bag').first();
          var unshoppable = '';

          // FE-292: Based on the inventory status we have implemented CTA
          if ($(slider.$slides[i]).find('.prod_inv_status-3').length || (Drupal.settings.globals_variables.display_notify_tos && $(slider.$slides[i]).find('.prod_inv_status-2').length)) {
            btnTxt = $(slider.$slides[i]).find('ul.product__inventory-status li.js-inv-status-3 .notify-status').first();
            unshoppable = ' slider_notify-me';
          } else if ($(slider.$slides[i]).find('.product--not-shoppable').length) {
            unshoppable = ' un-shoppable';
            btnTxt = $('.js-inv-status-7').first();
          }
          // "Static" add to bag button effect.
          var staticBtn = '<div class="collection-static-carousel-banner' + unshoppable + '">' + btnTxt.text() + '</div>';

          return staticBtn + (i + 1) + ' / ' + slider.slideCount + ' ' + localizedShades;
        }
      });
      // Unslick One Slide Carousels.
      carousel.each(function (index, element) {
        var slideCount = $(this).find('.slick-slide:not(.slick-cloned)').length,
          slidesToShow = $(this).slickGetOption('slidesToShow');

        if (slideCount <= slidesToShow) {
          $(this).unslick();
        }
      });
    },
    attach: function (context) {
      var self = this;
      var legacyView = 'collection-classic-product-column';

      if ($('.js-collection-landing-view-all').attr('href') && !$('.' + legacyView).length) {
        var $wrapper = $('.js-mobile-collection-single-products-wrapper', 'body');
        var $prodParent = $('.js-mobile-collection-slide', $wrapper);
        // create our grouping by prodid since all we have is a list of skus
        var mygroup = $prodParent.map(function () {
          return $(this).data('product-parent');
        }).get();
        var newU = _.uniq(mygroup);

        _.each(newU, function (matchID) {
          var $matchGroup = $wrapper.find("[data-product-parent='" + matchID + "']");

          // Add controls if there's more than one item.
          if ($matchGroup.length > 1) {
            // add markup we will need for a carousel
            $matchGroup.wrapAll('<div class="mobile-collection-products-carousel js-mobile-collection-products-carousel carousel carousel-collection" />');
            $matchGroup.append('<div class="carousel-controls collection-"><span class="count"></span></div>');
          } else {
            // add markup we will need for a carousel
            $matchGroup.wrapAll('<div class="mobile-collection-products-carousel js-mobile-collection-products-carousel carousel" />');
          }
        });
        self.loadCarousel();
        $(window).on('customMPP:inventory_sort:started', function () {
          self.destroyCarousel();
        });
        $(window).on('customMPP:inventory_sort:completed', function () {
          self.reloadCarousel();
        });
      }
    },
    destroyCarousel: function () {
      $('.js-mobile-collection-products-carousel', 'body').unslick();
    },
    reloadCarousel: function () {
      this.loadCarousel();
    }
  };
})(jQuery);
